"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 4.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2M10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.768 8.613c0-1.231 1.011-2.208 2.232-2.208s2.232.979 2.232 2.21c0 .976-.651 1.486-1.071 1.765-.174.115-.289.21-.361.306a.5.5 0 0 0-.1.318v.188a.7.7 0 1 1-1.4 0v-.188c0-.99.657-1.506 1.087-1.79.17-.113.279-.205.348-.297a.46.46 0 0 0 .097-.303.82.82 0 0 0-.832-.809.82.82 0 0 0-.832.808.7.7 0 1 1-1.4 0m1.43 4.325a.784.784 0 1 1 1.568-.01.784.784 0 0 1-1.568.01",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HelpIcon20.js.map